import useNewsletterRegistration from './useNewsletterRegistration';
export default useNewsletterRegistration;
